import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown } from '@fortawesome/pro-solid-svg-icons';
import AppLogo from '../shared/AppLogo';

/** EmbeddedMoreAppsButton — The help-row button with stacked logos: "3 more apps". */
export default function EmbeddedMoreAppsButton({
  apps,
  label,
  onClick,
}: {
  apps: { key: string; name: string; logo?: string }[];
  label: string;
  onClick: () => void;
}) {
  return (
    <button
      type="button"
      onClick={onClick}
      className="inline-flex h-8 items-center gap-2 rounded-full pr-2 pl-1.5 text-[13px] font-medium text-foreground hover:bg-accent"
    >
      <span aria-hidden="true" className="flex items-center">
        {apps.slice(0, 3).map((app, i) => (
          <AppLogo
            key={app.key}
            src={app.logo}
            name={app.name}
            className={`size-5 rounded-md border-2 border-card bg-white text-[7px] ${i > 0 ? '-ml-1.5' : ''}`}
          />
        ))}
      </span>
      {label}
      <FontAwesomeIcon
        icon={faChevronDown}
        aria-hidden="true"
        className="text-xs"
      />
    </button>
  );
}
